"use client";
import React, { useEffect, useState } from "react";
import { OnloadScheduledOrderModal } from "./onloadScheduleOrderModal";
import { isBusinessOpen } from "@/utils/isBusinessOpenUtil";
import {
  getFromSessionStorage,
  saveToSessionStorage,
} from "@/utils/sessionStorageUtils";
import { SessionStorageKey } from "@/utils/storageKeys";
import { Merchant } from "@/dto/merchant";
import { DayPart } from "@/dto/dayPartMenu";
import { useNativeActions } from "@/utils/useNativeActions";

interface OnLoadScheduleOrderProps {
  merchant: Merchant;
  merchantColor: string;
  selectedDayPart?: DayPart | null;
}

export const OnloadScheduleOrderPopup = ({
  merchant,
  merchantColor,
  selectedDayPart,
}: OnLoadScheduleOrderProps) => {
  const { isCmaApp } = useNativeActions();
  const isPopupTouched = getFromSessionStorage<boolean>(
    SessionStorageKey.ONLOAD_SCHEDULEDORDER_POPUP_ISTOUCHED,
    false
  );
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [isTouched, setIsTouched] = useState(!!isPopupTouched);
  const [isPreview, setIsPreview] = useState<boolean>(false);

  useEffect(() => {
    setIsPreview(globalThis.location.hostname.startsWith("preview-"));
  }, []);

  const closeModal = () => {
    const existingFlag = Boolean(isPopupTouched);
    saveToSessionStorage(
      SessionStorageKey.ONLOAD_SCHEDULEDORDER_POPUP_ISTOUCHED,
      !existingFlag
    );
    setIsTouched(!existingFlag);
    setIsModalOpen(false);
  };

  if (isTouched || isPreview || !isBusinessOpen(merchant) || isCmaApp)
    return null;

  return (
    <OnloadScheduledOrderModal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      merchant={merchant}
      selectedDayPart={selectedDayPart}
    />
  );
};
